// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"203":"c0bff66346277c75","638":"c60048a660634320"}[chunkId] + ".css";
};